import {
	CurrencyCodeIso,
	getCurrencySymbol,
} from "../../../common/constants/currency";
import { Pricing } from "../pricingListSlice";

export function enrichLabel(label?: string, pricing?: Pricing) {
	if (!label?.length) {
		return "";
	}
	return label.replaceAll(
		"[CURRENCY]",
		getCurrencySymbol(pricing?.currency ?? CurrencyCodeIso.EUR)
	);
}
